import { styled } from '../../Styles/stitches.config'

export const StyledModal = styled('div', {
    bgc: '$white',
    left: '50%',
    overflowY: 'auto',
    p: '$3',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '$default',
    zIndex: '$modal',

    variants: {
        fullscreen: {
            true: {
                br: 0,
                inset: 0,
                transform: 'none',
            },
            false: {
                '@mobile': {
                    maxW: 'calc(100% - 32px)',
                },

                '@desktop': {
                    maxW: 1168,
                },
            },
        },
    },
})
